export const getActiveCompetitions = () => {
  return fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/getactivecompetitions`);
};
